import stringToColor from './stringToColor';

export default function getHashColorClass(value: string) {
  const hash = stringToColor((value as string));
  switch (hash) {
    case 0:
      return 'UltraMarine';
    case 1:
      return 'SpaceCadet';
    case 2:
      return 'Sanguine';
    case 3:
      return 'Aqua';
    case 4:
      return 'Orange';
    case 5:
      return 'Purple';
    default:
      return 'Salmon';
  }
}
